<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-overlay
        variant="white"
        :show="loading"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
      >
        <b-card class="mb-0">
          <b-link class="brand-logo">
            <!-- logo -->
            <vuexy-logo />

            <h2 class="brand-text text-primary ml-1">
              МИГ
            </h2>
          </b-link>

          <b-card-title class="mb-1">
            Забыли пароль?
          </b-card-title>
          <b-card-text class="mb-2">
            Введите своей email и мы вышлем инструкцию по смену пароля
          </b-card-text>

          <!-- form -->
          <validation-observer
                  ref="form"
                  #default="{invalid}"
          >
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="sendPasswordResetEmail"
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="forgot-password-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    v-model="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit button -->
              <b-button
                variant="primary"
                block
                type="submit"
                :disabled="invalid"
              >
                Выслать ссылку востановления
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> Назад ко входу
            </b-link>
          </b-card-text>

        </b-card>

      </b-overlay>
    </div>
  </div>
</template>

<script>
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
    BOverlay,
    BCard, BCardTitle, BCardText,
    BForm, BFormGroup,
    BFormInput,
    BLink, BButton,
} from 'bootstrap-vue'

  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { required, email } from '@validations'

  import useAuthentication from './useAuthentication'


  export default {
    components: {
      VuexyLogo,
      BCard,
      BLink,
      BCardText,
      BCardTitle,
      BFormGroup,
      BFormInput,
      BButton,
      BForm,

      ValidationProvider,
      ValidationObserver,

      BOverlay
    },

     setup() {
        const {
          form,
          email,
          loading,
          sendPasswordResetEmail,
        } = useAuthentication()

        return {
          form,
          email,
          loading,
          sendPasswordResetEmail
        }
      }
  }
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
